<template>
  <div class="supplem">
    <div class="supplem-single">
      <div class="section-block send-block" :style="{paddingTop: type === 1 ? '20px' : '0'}">
        <div class="section-title" v-if="type === 1">发送新补材通知</div>
        <div class="tip" v-if="type==1"><i class="el-icon-warning-outline"></i>说明：请填写补材事项并生成通知，当事人可通过通知中的链接上传补材材料。
        </div>
        <el-form ref="formRef" :model="form" :rules="formRules" label-width="120px" class="section-form">
          <el-form-item label="通知类型" prop="informTypeCode">
            <el-select
                v-model="form.informTypeCode"
                placeholder="请选择通知类型"
                clearable
                style="width: 100%;"
            >
              <el-option
                  v-for="item in noticeTypeOptions"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="接收方" prop="acceptorCode">
            <el-select
                v-model="form.acceptorCode"
                placeholder="请选择接收方"
                clearable
                style="width: 100%;"
            >
              <el-option
                  v-for="item in receiverOptions"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="补材期限(天)" prop="deadline">
            <el-input
                v-model.number="form.deadline"
                type="number"
                placeholder="请输入天数"
                min="1"
                max="30"
                style="width: 100%;"
            />
            1-30天
          </el-form-item>
          <el-form-item label="通知日期" prop="informDate">
            <el-date-picker
                v-model="form.informDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择通知日期"
                style="width: 100%;"
                :disabled="true"
            />
          </el-form-item>
          <el-form-item label="补材内容" prop="identificationCaseMaterialContentList">
            <div class="input-box">
              <el-input
                  v-model="identificationCaseMaterialContent"
                  placeholder="请输入需要补充的材料"
                  resize="vertical"
              />
              <el-button type="primary" @click="addIdentificationCaseMaterialContent">添加</el-button>
              <el-button  @click="removeIdentificationCaseMaterialContent(-1)">清空全部</el-button>
            </div>
            <div style="padding-top: 12px">
              <div class="material-item" v-for="(item,index) in form.identificationCaseMaterialContentList" :key="index">
                <span>{{index+1}}</span>
                 <p>{{item.materialContent}}</p>
                <el-button type="danger" @click="removeIdentificationCaseMaterialContent(index)">删除</el-button>
              </div>
            </div>
            <p v-if="form.identificationCaseMaterialContentList.length==0">暂无补材内容，请点击"添加"按钮添加需要补充的材料</p>
          </el-form-item>
          <el-form-item label="补材事项说明" prop="supplementaryInstruction">
            <el-input
                v-model="form.supplementaryInstruction"
                type="textarea"
                :rows="4"
                placeholder="请输入补充说明"
                resize="vertical"
            />
          </el-form-item>
          <div class="edit-tip" v-if="type==2">
            编辑说明：修改后不会重新发送通知，状态变更为“已完成”时请填写完成日期。<br>
            自动计算：截止日期会根据通知日期和补材期限自动计算。
          </div>
          <el-form-item>
            <!--                            <el-button @click="handlePreview">预览通知</el-button>-->
            <el-button type="primary" :loading="sendLoading" @click="handleSend" v-if="step2Status!=2 && type === 1">发送补材通知</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 预览通知弹框 -->
    <el-dialog :visible.sync="previewVisible" title="预览通知" width="500px" append-to-body>
      <div class="preview-body">
        <p><strong>通知类型：</strong>{{ previewNoticeTypeLabel }}</p>
        <p><strong>接收方：</strong>{{ previewReceiverLabel }}</p>
        <p><strong>补材期限：</strong>{{ form.deadline }} 天</p>
        <p><strong>补充说明：</strong></p>
        <p class="preview-remark">{{ form.supplementaryInstruction || '-' }}</p>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {getListByDictType} from '@/api/sys/dictData'
import {sendSupplementaryNotice} from '@/api/recognition/survey'

export default {
  name: 'Supplem',
  props:{
    step2Status:{
      type:Number,
      default:null
    },
    type:{
      default: 1
    },
    rowData:{
      default:()=>{}
    }
  },
  data() {
    return {
      form: {
        informTypeCode: '',
        acceptorCode: '',
        deadline: 7,
        supplementaryInstruction: '',
        informDate: this.parseTime(new Date().getTime()),
        identificationCaseMaterialContentList:[]
      },
      formRules: {
        informTypeCode: [{required: true, message: '请选择通知类型', trigger: 'change'}],
        acceptorCode: [{required: true, message: '请选择接收方', trigger: 'change'}],
        deadline: [
          {required: true, message: '请输入补材期限', trigger: 'blur'},
          {type: 'number', min: 1, max: 30, message: '请输入 1-30 之间的天数', trigger: 'blur'}
        ],
        identificationCaseMaterialContentList:[
            {required: true, message: '请输入补材内容', trigger: 'change'}
        ]
      },
      identificationCaseMaterialContent:'',
      noticeTypeOptions: [],
      receiverOptions: [],
      sendLoading: false,
      previewVisible: false
    }
  },
  computed: {
    previewNoticeTypeLabel() {
      const opt = this.noticeTypeOptions.find((o) => o.dictValue === this.form.informTypeCode)
      return opt ? opt.dictLabel : '-'
    },
    previewReceiverLabel() {
      const opt = this.receiverOptions.find((o) => o.dictValue === this.form.acceptorCode)
      return opt ? opt.dictLabel : '-'
    }
  },
  created() {
    this.loadDictData();
    this.getDetail()
  },
  methods: {
    async loadDictData() {
      const dictTypes = [
        {key: 'noticeTypeOptions', type: 'industrial_injury_supplement_notice_type'},
        {key: 'receiverOptions', type: 'industrial_injury_supplement_receiver'}
      ]
      for (const {key, type} of dictTypes) {
        try {
          const res = await getListByDictType(type)
          if (res && res.code === 200 && res.data) {
            this[key] = res.data
          }
        } catch (e) {
          console.warn(`字典 ${type} 加载失败`, e)
        }
      }
    },
    handlePreview() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.previewVisible = true
        }
      })
    },
    handleSend() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return
        this.sendLoading = true
        let caseId = this.$route.query.id
        this.form.caseId = caseId
        this.form.acceptorName = this.selectDictLabel(this.receiverOptions, this.form.acceptorCode);
        this.form.informTypeName =this.selectDictLabel(this.noticeTypeOptions, this.form.informTypeCode);
        sendSupplementaryNotice(this.form).then(res => {
          if (res && res.code === 200) {
            this.$message.success('发送成功')
            this.sendLoading = false
          }
        }).finally(()=>{
          this.sendLoading = false
        })
      })
    },
    addIdentificationCaseMaterialContent(){
      if (!this.identificationCaseMaterialContent){
        this.$message.error('请输入补材内容')
        return
      }
      this.form.identificationCaseMaterialContentList.push({materialContent:this.identificationCaseMaterialContent})
      this.identificationCaseMaterialContent = ''
    },
    removeIdentificationCaseMaterialContent(index){
      if (index === -1){
        this.form.identificationCaseMaterialContentList=[]
        return
      }
      if (index !== -1){
        this.form.identificationCaseMaterialContentList.splice(index, 1)
      }
    },
    getDetail(){
      if (!this.id && this?.rowData?.id){
        for (const argumentsKey in this.rowData) {
          if (this.form[argumentsKey] !== undefined) {
            this.form[argumentsKey] = this.rowData[argumentsKey]
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.supplem {
  width: 100%;
  height: 100%;
}

.supplem-single {
  flex: 1;
}

.section-block {
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 0;

  .section-title {
    position: relative;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    padding-left: 11px;
    margin-bottom: 12px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 12px;
      border-radius: 20px;
      background: var(--vt-c-blue);
    }
  }
}

.send-block {
  min-height: 200px;
}

.preview-body {
  p {
    margin-bottom: 12px;
    font-size: 14px;
  }

  .preview-remark {
    white-space: pre-wrap;
    color: #606266;
  }
}

.tip {
  height: 44px;
  display: flex;
  place-content: center;
  place-items: center;
  gap: 10px;
  flex-shrink: 0;
  padding: 8px 16px;
  border-radius: 4px;
  background: rgba(254, 237, 238, 1);
  color: rgba(255, 62, 80, 1);
  font-family: "Alibaba PuHuiTi 3.0";
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 10%;
  margin-bottom: 24px;
}
.edit-tip{
  display: flex;
  gap: 10px;
  flex-shrink: 0;
  padding: 12px 16px;
  border-radius: 4px;
  background: rgba(254, 237, 238, 1);
  color: rgba(255, 62, 80, 1);
  font-family: "Alibaba PuHuiTi 3.0";
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 10%;
  margin-top: 24px;
}
.input-box{
  display: flex;
  gap: 12px;
}
.material-item{
  margin-bottom: 10px;
  display: flex;
  gap: 10px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  align-items: center;
  padding: 12px;
  span{
    display: inline-block;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background: #1890ff;
    color: #fff;
    border-radius:50%;
    font-size: 12px;
  }
  p{
    flex: 1;
  }
}
</style>
